module.exports = __webpack_public_path__ + "assets/perinatalmedcenter.da8c204a55985e097826ca478b7eadcbc0564daf552703ff24804fe5e09c721f.png";